import { useState, useEffect } from "react";
import axios from "axios";
import ListaReclamos from "../../componentesEspeciales/reclamosAdmin/listaReclamos";

const TABS = [
    { key: "todos",       label: "Todos"        },
    { key: "abierto",     label: "Abiertos"     },
    { key: "en_revision", label: "En revisión"  },
    { key: "resuelto",    label: "Resueltos"    },
    { key: "cerrado",     label: "Cerrados"     },
];

function TileResumen({ label, valor, color, icono }) {
    return (
        <div className="rounded-4 p-3" style={{ background: `${color}0f`, border: `1px solid ${color}22` }}>
            <div className="d-flex align-items-center gap-2 mb-1">
                <i className={`bi ${icono}`} style={{ color, fontSize: 14 }}></i>
                <span style={{ fontSize: "0.78rem", color: "var(--color-text-secondary)", fontWeight: 500 }}>{label}</span>
            </div>
            <div style={{ fontSize: "1.45rem", fontWeight: 700, color: "var(--color-text-primary)", lineHeight: 1 }}>{valor}</div>
        </div>
    );
}

function Reclamos() {
    const [tab, setTab]           = useState("todos");
    const [pagina, setPagina]     = useState(1);
    const [busqueda, setBusqueda] = useState("");
    const [query, setQuery]       = useState("");
    const [datos, setDatos]       = useState(null);
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        let activo = true;
        (async () => {
            try {
                setCargando(true);
                const res = await axios.post("/listar-reclamos-admin", { params: { pagina, estado: tab, busqueda: query } });
                if (activo && res.data.exito) setDatos(res.data);
            } catch { /* silencioso */ } finally { if (activo) setCargando(false); }
        })();
        return () => { activo = false; };
    }, [pagina, tab, query]);

    const reservas = datos?.reservas || [];
    const total    = datos?.total    || 0;
    const paginas  = datos?.paginas  || 1;
    const resumen  = datos?.resumen  || {};

    const totalAbiertos  = resumen.abierto || 0;
    const totalRevision  = resumen.en_revision || 0;
    const totalResueltos = (resumen.resuelto_a_favor_comprador || 0) + (resumen.resuelto_a_favor_proveedor || 0);
    const totalCerrados  = resumen.cerrado || 0;
    const totalTodos     = totalAbiertos + totalRevision + totalResueltos + totalCerrados;

    function cambiarTab(t) {
        setTab(t);
        setPagina(1);
    }

    function handleBuscar(e) {
        e.preventDefault();
        setQuery(busqueda);
        setPagina(1);
    }

    return (
        <div className="container-fluid pb-5">
            {/* Cabecera */}
            <div className="d-flex justify-content-between align-items-start pt-3 pb-2 mb-4 border-bottom flex-wrap gap-3">
                <div>
                    <h1 className="h4 fw-bold text-dark mb-0">Reclamos</h1>
                    <p className="text-muted small mb-0 mt-1">Disputas abiertas por compradores sobre servicios prestados.</p>
                </div>
            </div>

            {/* Tiles resumen */}
            <div className="row g-3 mb-4">
                <div className="col-6 col-md-3 col-lg" style={{ minWidth: 0 }}>
                    <TileResumen label="Abiertos"   valor={totalAbiertos}  color="var(--rojo-600)" icono="bi-exclamation-circle-fill" />
                </div>
                <div className="col-6 col-md-3 col-lg" style={{ minWidth: 0 }}>
                    <TileResumen label="En revisión" valor={totalRevision}  color="var(--ambar-600)" icono="bi-search"                  />
                </div>
                <div className="col-6 col-md-3 col-lg" style={{ minWidth: 0 }}>
                    <TileResumen label="Resueltos"   valor={totalResueltos} color="var(--azul-logo-claro)" icono="bi-check2-all"              />
                </div>
                <div className="col-6 col-md-3 col-lg" style={{ minWidth: 0 }}>
                    <TileResumen label="Cerrados"    valor={totalCerrados}  color="var(--gris-400)" icono="bi-x-circle"               />
                </div>
                <div className="col-6 col-md-3 col-lg" style={{ minWidth: 0 }}>
                    <TileResumen label="Total"       valor={totalTodos}     color="var(--gris-700)" icono="bi-shield-exclamation"      />
                </div>
            </div>

            {/* Tabs + búsqueda */}
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
                <div className="d-flex gap-2 flex-wrap">
                    {TABS.map(t => (
                        <button key={t.key}
                            className={`btn btn-sm rounded-pill px-3 fw-semibold ${tab === t.key ? "btn-dark" : "btn-outline-secondary"}`}
                            onClick={() => cambiarTab(t.key)}>
                            {t.label}
                        </button>
                    ))}
                </div>
                <form className="d-flex gap-2" onSubmit={handleBuscar}>
                    <input
                        className="form-control form-control-sm rounded-pill"
                        placeholder="Buscar por servicio…"
                        value={busqueda}
                        onChange={e => setBusqueda(e.target.value)}
                        style={{ width: 220 }}
                    />
                    <button className="btn btn-sm btn-outline-secondary rounded-pill px-3" type="submit">
                        <i className="bi bi-search"></i>
                    </button>
                    {query && (
                        <button className="btn btn-sm btn-outline-danger rounded-pill px-3" type="button"
                            onClick={() => { setQuery(""); setBusqueda(""); setPagina(1); }}>
                            <i className="bi bi-x"></i>
                        </button>
                    )}
                </form>
            </div>

            {cargando ? (
                <div className="text-center py-5 text-muted">
                    <span className="spinner-border spinner-border-sm me-2"></span>Cargando...
                </div>
            ) : (
                <ListaReclamos
                    reservas={reservas}
                    total={total}
                    pagina={pagina}
                    paginas={paginas}
                    onPagina={p => { setPagina(p); window.scrollTo(0, 0); }}
                />
            )}
        </div>
    );
}

export default Reclamos;
